import { TLF_VIEW_MODES, TlfViewModeConfig } from "aic";

// Helper functions for localStorage
const TLF_VIEW_MODE_STORAGE_KEY = "tlfViewMode";

/**
 * Loads the TLF view mode configuration from localStorage.
 *
 * @returns The TLF view mode configuration loaded from localStorage, or the default if not found
 */
export const loadTlfViewModeFromStorage = (): TlfViewModeConfig => {
  try {
    const stored = localStorage.getItem(TLF_VIEW_MODE_STORAGE_KEY);
    if (stored && TLF_VIEW_MODES.map((mode) => mode.value).includes(stored)) {
      return TLF_VIEW_MODES.find((mode) => mode.value === stored)!;
    }
  } catch {
    // Fall back to default if localStorage is not available or contains invalid data
  }
  return TLF_VIEW_MODES[0];
};

/**
 * Saves the TLF view mode configuration to localStorage.
 *
 * @param viewMode - The TLF view mode configuration to save to localStorage
 */
export const saveTlfViewModeToStorage = (viewMode: TlfViewModeConfig): void => {
  try {
    localStorage.setItem(TLF_VIEW_MODE_STORAGE_KEY, viewMode.value);
  } catch {
    // Ignore localStorage errors
  }
};
